import { Obj } from '../entity.js'
import { InstanceObjOptions, ObjOptions } from './base.js'

export interface EventObjOptions extends ObjOptions {
  schema?: unknown
}

export class EventObj extends Obj<'Event'> {
  readonly typeOf = 'Event' as const
  schema?: unknown

  public constructor(opts: EventObjOptions) {
    super({ ...opts, typeOf: 'Event' })
    if (opts.schema !== undefined) {
      this.schema = opts.schema
    }
  }
}

export function isEventObj(obj: any): obj is EventObj {
  return obj.typeOf === 'Event'
}

export class EventInstanceObj extends Obj<'EventInstance'> {
  readonly typeOf = 'EventInstance' as const

  public constructor(opts: InstanceObjOptions) {
    super({ ...opts, typeOf: 'EventInstance' })
  }

  override get instanceOfId(): string | undefined {
    if (this.instanceOf) {
      return `Event/${this.instanceOf}`
    }
    return undefined
  }
}

export function isEventInstanceObj(obj: any): obj is EventInstanceObj {
  return obj.typeOf === 'EventInstance'
}

export class ErrorEventObj extends Obj<'ErrorEvent'> {
  readonly typeOf = 'ErrorEvent' as const

  public constructor(opts: ObjOptions) {
    super({ ...opts, typeOf: 'ErrorEvent' })
  }
}

export function isErrorEventObj(obj: any): obj is ErrorEventObj {
  return obj.typeOf === 'ErrorEvent'
}

export interface ErrorEventInstanceObjOptions extends InstanceObjOptions {
  message: string
  code?: string
  stack?: string
  cause?: Error
  severity?: 'error' | 'warning' | 'info' | 'critical'
}

export class ErrorEventInstanceObj extends Obj<'ErrorEventInstance'> {
  readonly typeOf = 'ErrorEventInstance' as const
  message: string
  code?: string
  stack?: string
  cause?: Error
  severity: 'error' | 'warning' | 'info' | 'critical' = 'error'

  /** Error occurrence time is tracked via createdAt */
  public constructor(opts: ErrorEventInstanceObjOptions) {
    super({ ...opts, typeOf: 'ErrorEventInstance' })
    this.message = opts.message
    if (opts.code !== undefined) {
      this.code = opts.code
    }
    if (opts.stack !== undefined) {
      this.stack = opts.stack
    }
    if (opts.cause !== undefined) {
      this.cause = opts.cause
    }
    this.severity = opts.severity || 'error'
  }

  override get instanceOfId(): string | undefined {
    if (this.instanceOf) {
      return `ErrorEvent/${this.instanceOf}`
    }
    return undefined
  }
}

export function isErrorEventInstanceObj(obj: any): obj is ErrorEventInstanceObj {
  return obj.typeOf === 'ErrorEventInstance'
}
